import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { cardItemHoverAnimation } from 'tripPlanner/utils/css'

const Container = styled.div`
  width: ${rem(260)};

  ${mediaQueryUp.tablet} {
    width: ${rem(280)};
  }

  background: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${(props) => props.theme.borderRadius.M};

  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  align-items: center;
  place-content: center;
  overflow: hidden;

  ${cardItemHoverAnimation}
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: fit-content;
  gap: ${rem(8)};
  align-items: center;
`

export default function CarouselCTACard({ children }: PropsWithChildren) {
  const intl = useIntl()

  return (
    <Container>
      <BodyText variant="small" weight="bold">
        {intl.formatMessage({
          id: 'xqsiJgWNul9v3-WXES0H',
          defaultMessage: 'Not quite what you’re looking for?',
          description: 'Prompt shown on the carousel CTA card suggesting user explore more offers',
        })}
      </BodyText>
      <Wrapper>{children}</Wrapper>
    </Container>
  )
}
